module.exports = __webpack_public_path__ + "static/media/enrpi-mobile-screens.d6a92b14.png";